// extracted by mini-css-extract-plugin
export default {"navLink":"navbar_navLink__sAvr+"};